import React from "react";

const Contact: React.FC = () => {
    return (
        <section id="contact" className="pdtopBottmSection">
            <div className="container">
            <div>
                <div className="section-label">Get In Touch</div>
                <h2 className="section-title">Let’s Find Your<br /><em>Ideal</em> Property</h2>
                <p className="contact-sub">Whether you are a first-time overseas buyer or a seasoned investor expanding your portfolio, our team is ready to guide you.</p>

                <div className="contact-info">
                <div className="contact-info-item">
                    <div className="contact-info-label">Phone</div>
                    <div className="contact-info-value">+90 555 080 11 00</div>
                </div>
                <div className="contact-info-item">
                    <div className="contact-info-label">Website</div>
                    <div className="contact-info-value">www.investaestates.com</div>
                </div>
                <div className="contact-info-item">
                    <div className="contact-info-label">Office</div>
                    <div className="contact-info-value">Ortabayır Mah. Şair Çelebi Sk.<br />Gurtaş İş Merkezi No:1, Kat 3<br />Kağıthane / İstanbul</div>
                </div>
                </div>
            </div>

            <form className="contact-form reveal">
                <div className="form-field">
                <label className="form-label" htmlFor="fullname">Full Name</label>
                <input id="fullname" type="text" className="form-input" placeholder="Your name" />
                </div>
                <div className="form-field">
                <label className="form-label" htmlFor="email">Email Address</label>
                <input id="email" type="email" className="form-input" placeholder="your@email.com" />
                </div>
                <div className="form-field">
                <label className="form-label" htmlFor="budget">Budget Range</label>
                <select id="budget" className="form-select">
                    <option>$100,000 – $200,000</option>
                    <option>$200,000 – $400,000</option>
                    <option>$400,000+ (Citizenship)</option>
                    <option>Flexible / Advisory</option>
                </select>
                </div>
                <div className="form-field">
                <label className="form-label" htmlFor="message">Message</label>
                <textarea id="message" className="form-textarea" placeholder="Tell us what you're looking for…"></textarea>
                </div>
                <button type="button" className="form-submit">Send Enquiry</button>
            </form>
            </div>
        </section>
    )
}

export default Contact;